<script>
  import Counter2 from "../../../Publish/BulkUpload/Shared/counter2.svelte"
  export let statRate = {
    sent: 0,
    delivered: 0,
    bounced: 0,
    open: 0,
  }
</script>

<div class="grid grid-cols-1 items-center gap-3 sm:grid-cols-2">
  <Counter2 span="col-span-2" count={statRate.sent || 0} icon={"fa-envelope-circle-check"} titleText={"SENT"} color={"#ff6a00"} gradient={"#f8a500, #ff6a00"} />
  <Counter2 span="col-span-2" count={statRate.delivered || 0} icon={"fa-envelope-dot"} titleText={"DELIVERED"} color={"#00D515"} gradient={"#58FE69, #00D515"} />
  <Counter2 span="col-span-2" count={statRate.bounced || 0} icon={"fa-circle-exclamation"} titleText={"BOUNCED"} color={"#F03232"} gradient={"#F87A7A, #F03232"} />
  <Counter2 span="col-span-2" count={statRate.open || 0} icon={"fa-envelope-open"} titleText={"OPEN"} color={"#00B2FF"} gradient={"#A3E3FF, #00B2FF"} />
</div>
